export default __webpack_public_path__ + "static/media/seven_lc1.1ad02fab.png";